export default "__VITE_ASSET__Cc5wu4Yb__"